import { render, staticRenderFns } from "./SectionPartner.vue?vue&type=template&id=57dcb815&scoped=true"
import script from "./SectionPartner.vue?vue&type=script&lang=ts"
export * from "./SectionPartner.vue?vue&type=script&lang=ts"
import style0 from "./SectionPartner.vue?vue&type=style&index=0&id=57dcb815&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dcb815",
  null
  
)

export default component.exports